/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_ProductInputs */

const en_qk_product = /** @type {(inputs: Qk_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product key`)
};

const de_qk_product = /** @type {(inputs: Qk_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktschlüssel`)
};

/**
* | output |
* | --- |
* | "Product key" |
*
* @param {Qk_ProductInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_product = /** @type {((inputs?: Qk_ProductInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_ProductInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_product(inputs)
	return en_qk_product(inputs)
});